export default __webpack_public_path__ + "static/media/grid.5e450c1b.svg";